export default __webpack_public_path__ + "static/media/earn.452f368d.svg";